/**
 * Simple utility for handing flags.
 */
export class FlagUtility {
    public static setFlag(currentValue: number, flag: number): number {
        return currentValue |= flag;
    }

    public static clearFlag(currentValue: number, flag: number): number {
        return currentValue & ~flag;
    }

    public static hasFlag(currentValue: number, flag: number): boolean {
        return (currentValue & flag) === flag;
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Utility/FlagUtility.ts